import { useEffect } from 'react';

function isMobileDevice() {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const uaMobile = /Android|iPhone|iPad|iPod/i.test(ua);
  const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  const narrow = window.innerWidth < 1024;

  return uaMobile || (coarse && narrow);
}

export default function useAndroidBody() {
  useEffect(() => {
    if (!isMobileDevice()) {
      // On desktop: do nothing – keep light theme
      return;
    }

    const body = document.body;
    body.classList.add('android-body');

    // Cleanup when page unmounts
    return () => {
      body.classList.remove('android-body');
    };
  }, []);
}
